import * as types from "../../constants/action-types";

export function setResults(payload) {
    return {type:types.SET_RESULTS , payload};
}
export function setAutoCompleteResults(payload) {
    return {type:types.SET_AUTOCOMPLETE_RESULTS , payload};
}

export function setManufacturersResults(payload) {
    return {type:types.SET_MANUFACTURERS, payload};
}

export function setCarsResults(payload) {
    return {type: types.SET_CARS, payload};
}

export function setSearchResults(payload) {
    return {type: types.SET_SEARCH, payload};
}

export function setRefresh(payload) {
    return {type: types.SET_REFRESH, payload};
}

export function setCarResults(payload) {
    return {type: types.SET_CAR, payload};
}

export function getLeadStatus(payload) {
    return{type: types.GET_LEAD, payload};
}

export function setValidationSMS(payload) {
    return{type: types.GET_SMS_VALIDATION, payload};
}

export function setOrderDetails(payload) {
    return {type: types.SET_ORDER_DETAILS, payload};
}

export function setContentPage(payload) {
    return {type:types.SET_CONTENT_PAGE, payload};
}

export function setFavorites(payload) {
    return {type: types.SET_FAVORITES, payload};
}

export function setCG(payload) {
    return {type:types.SET_CG, payload};
}

export function setAppointments(payload) {
    return {type:types.SET_APPOINTMENTS, payload};
}

export function setSMS(payload) {
    return {type: types.SET_SMS, payload};
}

export function setSummary(payload) {
    return {type: types.SET_SUMMARY, payload};
}

export function setMetaTags(payload) {
    return{type: types.SET_META_TAGS, payload}
}

export function setResultsFilters(payload) {
    return{type: types.SET_RESULTS_FILTERS, payload}
}